import req from './req'

/**
 * 素材库上传图片
 * @param {*} params
 * @returns
 */
export function uploadQiniuPic (params) {
  return req.post('/external/image/add', params)
}
/**
 * 素材库上传video
 * @param {} params
 * @returns
 */
export function uploadQiniuVideo (params) {
  return req.post('/external/image/add', params)
}
/**
 * 素材库获取图片列表
 * @param {} params
 * @returns
 */
export function getQiniuPicList (params) {
  return req.get('/external/image/list', params)
}

/**
 * 素材库获取video列表
 * @param {*} query
 * @returns
 */
export function getQiniuVideoList (params) {
  return req.get('/external/image/list', params)
}
/**
 * 素材库删除图片
 * @param {} params
 * @returns
 */
export function deleteImage (params) {
  return req.post('/external/image/del', params)
}
/**
 * 素材库删除video
 * @param {*} query
 * @returns
 */
export function deleteVideo (params) {
  return req.post('/external/image/del', params)
}
